<div *ngIf="dataLoaded">
  <div class="title-cost-wrap" *ngIf="expense.categoryType == ExpenseCategoryType.Distance">
    <div class="left">
      <span class="result-heading title">{{ expense.categoryName }}</span>
      <span class="result-heading cost">
        {{ expense.distanceAmount }} {{ expense.distanceUnit }}
        <span *ngIf="expense.amount > 0">/ {{ expense.currency}} {{ expense.amount | number:'1.2-2' }}</span>
      </span>
    </div>
  </div>

  <div class="title-cost-wrap" *ngIf="expense.categoryType == ExpenseCategoryType.Value">
    <div class="left">
      <span class="result-heading title">
      <app-expense-ai-category
        [categoryName]="expense.categoryName"
        [hasAiData]="hasAiReceiptData"
        [matches]="receiptCategoryMatches"
        [mismatchReason]="categoryMismatchReason">
      </app-expense-ai-category>
      <span *ngIf="expense.subCategory !== null && expense.subCategory !== ExpenseSubCategory.None">
        - {{ expense.subCategory | enumToText:ExpenseSubCategory }}
      </span>
    </span>
      <span class="result-heading cost">
      <app-expense-ai-amount
        [currency]="expense.currency"
        [amount]="expense.amount"
        [hasAiData]="hasAiReceiptData"
        [matches]="receiptAmountMatches"
        [mismatchReason]="receiptMismatchReason"
        [showNegative]="expense.subCategory === ExpenseSubCategory.CardPreloadRedemption">
      </app-expense-ai-amount>
    </span>
    </div>

    @if (expense.dailySpendExpensesEnabled) {
      <span class="result-heading receipt-date" *ngIf="hasAiReceiptData">
        <app-expense-ai-receipt-date [receipts]="expense.receipts" [visitDate]="expense.visitDate" [visitEndDate]="expense.visitEndDate" [visitTravelDays]="expense.visitTravelDays"></app-expense-ai-receipt-date>
      </span>
    }
  </div>
</div>

<div *ngIf="!dataLoaded" class="title-cost-wrap">
  <div class="loaders">
    <ngx-skeleton-loader style="width: 12%;"></ngx-skeleton-loader>
    <ngx-skeleton-loader style="width: 11%;"></ngx-skeleton-loader>
  </div>
</div>
